import { AccentId, ThemeMode } from "./types";

/** Same key as web-app so preference is shared when origins allow. */
export const THEME_STORAGE_KEY = "plai-theme-preference";

export const THEME_MODES: ThemeMode[] = ["light", "dark", "system"];

export const DEFAULT_THEME_MODE: ThemeMode = "light";

export const THEME_QUERY_PARAM = "theme";

/** Same key as web-app accent preference. */
export const ACCENT_STORAGE_KEY = "plai-accent-preference";

export const ACCENT_QUERY_PARAM = "accent";

export const DEFAULT_ACCENT: AccentId = "default";

export const ACCENT_IDS: AccentId[] = [
  "default",
  "kind-of-blue",
  "funky-fresh",
  "jazz-club",
  "electric-fusion",
  "brassy",
  "sunglasses-inside",
  "aubergine",
  "clementine",
  "banana",
  "jade",
  "lagoon",
  "barbra",
  "gray",
  "mood-indigo",
  "tritanopia",
  "protanopia-deuteranopia",
  "raspberry-beret",
  "big-business",
  "pog",
  "mint-chip",
  "pb-j",
  "chill-vibes",
  "forest-floor",
  "horizon",
  "sea-glass",
  "lemon-lime",
  "falling-leaves",
  "sunrise",
];
